import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b70d46fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "small-reco" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isMobile())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: `${_ctx.recoHasSmall}`,
            target: "blank",
            class: "underline"
          }, _toDisplayString(_ctx.recoHasSmall), 9, _hoisted_2))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: 'medics://viewer?m_source=' + _ctx.recoHasSmall,
            class: "underline"
          }, _toDisplayString(_ctx.recoHasSmall), 9, _hoisted_3))
    ])
  ]))
}